import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';

export const useDeleteRegion = () => {
  return useMutation((regionID: string) => {
    return countriesService.deleteRegion(regionID);
  });
};
